<template>
  <div class="copyright"
    :class="{'is-fixed': fixed}">
    —京东金融<template v-for="item in copyrightList"><img src="@/assets/icon-close.png"/>{{item}}</template>联合出品—
  </div>
</template>

<script>
  export default {
    props: {
      fixed: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        copyrightList: window.CONFIG.copyrightList
      };
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/px2rem.scss";
  
  .copyright {
    &.is-fixed {
      position: fixed;
      bottom: px2rem(88);
      left: 0;
      margin-bottom: 0;
    }
    margin-bottom: px2rem(88);
    width: 100%;
    text-align: center;
    color: #ccc;
    font-size: px2rem(24);
    img {
      width: px2rem(24);
      margin: 0 px2rem(5);
      vertical-align: middle;
    }
  }
</style>
